const api = 'https://api.erepositorio.focosistemas.com.br/'

export default api;